module.exports = __webpack_public_path__ + "static/img/5en.4b931ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/desc/02keepAlive/oppo/5en.png
// module id = pcFb
// module chunks = 0